import noUiSlider from 'nouislider';

const crtSlider = document.getElementById('crtSlider');

noUiSlider.create(crtSlider, {
    step: 0.1,
    start: 0.5,
    connect: true,
    range: {
        min: 0.1,
        max: 1,
    },
});

const crtSliderValue = document.getElementById('crtSliderValue');

const crtImage = document.getElementById('crtImage');

crtSlider.noUiSlider.on('update', (e) => {
    crtSliderValue.innerHTML = e;

    const width = e * 40;

    crtImage.style.width = `${width}px`;
    crtImage.style.height = `${width}px`;
});
